var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Tooltip, TooltipPosition } from '@patternfly/react-core';
import React from 'react';
var LongTextTooltip = function (_a) {
    var _b = _a.content, content = _b === void 0 ? '' : _b, _c = _a.maxLength, maxLength = _c === void 0 ? Infinity : _c, _d = _a.tooltipMaxWidth, tooltipMaxWidth = _d === void 0 ? '50vw' : _d, _e = _a.tooltipPosition, tooltipPosition = _e === void 0 ? TooltipPosition.top : _e, rest = __rest(_a, ["content", "maxLength", "tooltipMaxWidth", "tooltipPosition"]);
    var truncate = function (str, max) { return (str.length > max ? str.substr(0, max - 1) + '…' : str); };
    return content.length > maxLength ? (React.createElement(Tooltip, __assign({ maxWidth: tooltipMaxWidth, position: tooltipPosition, content: React.createElement("div", null, content) }, rest),
        React.createElement("div", null, truncate(content, maxLength)))) : (React.createElement("span", null, content));
};
export default LongTextTooltip;
//# sourceMappingURL=LongTextTooltip.js.map